// Shared EOL classification. Used by InformationSection's version list rows
// and VersionField's dropdown (OrgComponentVersion, eol_date field), and
// by DependenciesSection's rows (FactsheetDependency, eol field) too, so all
// three never drift out of sync on thresholds, colors, or wording.
const EOL_WARNING_WINDOW_MONTHS = 6

// 'none' (no date set, stays fully neutral, no color added at all),
// 'expired' (past), 'warning' (within the next 6 months), or 'healthy'
// (more than 6 months out). String-sliced date comparison, not a Date/time
// one. These are plain dates with no time component, and today itself
// shouldn't read as already-expired.
export function eolStatus(eolDateString) {
  if (!eolDateString) return 'none'

  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const warningCutoff = new Date(today)
  warningCutoff.setMonth(warningCutoff.getMonth() + EOL_WARNING_WINDOW_MONTHS)

  const eol = new Date(`${String(eolDateString).slice(0, 10)}T00:00:00`)

  if (eol < today) return 'expired'
  if (eol <= warningCutoff) return 'warning'
  return 'healthy'
}

// Convenience wrapper for version records with an eol_date field
// (OrgComponentVersion, FactsheetDependency).
export function versionEolStatus(version) {
  return eolStatus(version?.eol_date)
}

export const VERSION_EOL_TEXT_CLASSES = {
  none: 'text-gray-300 dark:text-gray-600 italic',
  healthy: 'text-green-700 dark:text-green-400',
  warning: 'text-amber-700 dark:text-amber-400 font-semibold',
  expired: 'text-red-600 dark:text-red-400 font-semibold',
}

export const VERSION_EOL_BADGE_CLASSES = {
  healthy: 'bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400',
  warning: 'bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400',
  expired: 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400',
}

export const VERSION_EOL_BADGE_LABELS = {
  healthy: 'Supported',
  warning: 'Expiring soon',
  expired: 'Expired',
}
